export enum Locale {
  AR = "ar",
  EN = "en",
  RU = "ru",
}
